import { ActionRegistry } from "./ActionRegistry";
import { ConditionRegistry } from "./ConditionRegistry";

export function createBuiltinConditionRegistry(): ConditionRegistry {
  const registry = new ConditionRegistry();

  registry.register("entityMoved", {
    event: "entity:moved",
    matches: (payload, condition) => payload.entityId === condition["entity"],
  });

  registry.register("artifactInspected", {
    event: "artifact:discovered",
    matches: (payload, condition) => payload.artifactId === condition["artifact"],
  });

  registry.register("entityApproached", {
    event: "entity:approached",
    matches: (payload, condition) => payload.targetId === condition["entity"],
  });

  registry.register("entityLeft", {
    event: "entity:left",
    matches: (payload, condition) => payload.targetId === condition["entity"],
  });

  registry.register("itemCombined", {
    event: "combine:success",
    matches: (payload, condition) => payload.produces === condition["produces"],
  });

  return registry;
}

export function createBuiltinActionRegistry(): ActionRegistry {
  const registry = new ActionRegistry();

  registry.register("reveal", {
    execute: (context, action) => {
      const entityId = action["entity"];
      if (typeof entityId !== "string") throw new Error('"reveal" action requires a string "entity"');
      context.world.revealEntity(entityId);
    },
  });

  registry.register("unlockKnowledge", {
    execute: (context, action) => {
      const nodeId = action["knowledge"];
      if (typeof nodeId !== "string") throw new Error('"unlockKnowledge" action requires a string "knowledge"');
      context.knowledge.unlock(nodeId, "understood");
      context.events.emit("knowledge:unlocked", { nodeId, state: "understood" });
    },
  });

  return registry;
}
